import { render, staticRenderFns } from "./VDynamicModal.vue?vue&type=template&id=37f7af06&scoped=true"
import script from "./VDynamicModal.vue?vue&type=script&lang=js"
export * from "./VDynamicModal.vue?vue&type=script&lang=js"
import style0 from "./VDynamicModal.vue?vue&type=style&index=0&id=37f7af06&prod&scoped=true&lang=css"
import style1 from "./VDynamicModal.vue?vue&type=style&index=1&id=37f7af06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f7af06",
  null
  
)

export default component.exports